export default __webpack_public_path__ + "static/media/meeting1.953f3e88.svg";